import { useContext, useMemo } from "react";
import { AuthContext, IAuthContext } from "@/context/Authentication";

export function useAuth(): IAuthContext {
  const { token, isAuthenticated, login, logout } = useContext(AuthContext) as IAuthContext || {};

  return useMemo(() => {
    return {
      token,
      isAuthenticated,
      login,
      logout
    };
  }, [token, isAuthenticated, login, logout]);
}
